import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function loadSopWarningConfig(params) {
  return request({
    url: URL.sys.loadSopWarningConfig,
    method: 'get',
    params
  })
}

export function save(data) {
  return request({
    url: URL.sys.saveSopWarningConfig,
    method: 'post',
    data
  })
}
